import { useState, useEffect } from 'react'
import { get, deleteAPI } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import FormLoader from '../../../../components/loader/FormLoader'
import { Icon } from '@iconify/react'
import CreateNotification from './CreateNotification'

function Notifications() {
  const { notify, profile } = useGlobalContext()
  const [notificationLists, setNotificationLists] = useState<any>({ data: [] })
  const [loading, setLoading] = useState(true)
  const [createNotification, setCreateNotification] = useState(false)
  const [selectedNotification, setSelectedNotification] = useState(null)

  function fetchNotifications() {
    setLoading(true)
    let url = 'notifications'

    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setNotificationLists(result)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  useEffect(() => {
    fetchNotifications()
  }, [])

  function handleDeleteNotification(notificationId: string) {
    if (!confirm('Are you sure you want to delete this notification?')) {
      return
    }

    deleteAPI(`notifications/${notificationId}`)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Notification deleted successfully')
          fetchNotifications()
        } else {
          notify('error', result.message || 'Failed to delete notification')
        }
      })
      .catch(() => {
        notify('error', 'Failed to delete notification')
      })
  }

  return (
    <div className='home'>
      {createNotification && (
        <CreateNotification
          selectedNotification={selectedNotification}
          fetchNotifications={fetchNotifications}
          setShowNotification={setCreateNotification}
          setSelectedNotification={setSelectedNotification}
        />
      )}
      <div className='home_tag flex justify-between'>
        <span></span>
        {profile.role === 'super admin' && (
          <button
            onClick={() => {
              setCreateNotification(true)
              setSelectedNotification(null)
            }}
          >
            Create Notification
          </button>
        )}
      </div>
      <div className='home_tables'>
        <div className='left'>
          <div className='flex justify-between items-center search-btns flex-wrap'></div>
          {loading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {notificationLists.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {notificationLists.map((item: any, i: number) => (
                      <div className='card' key={item._id}>
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Title</h4>
                          <p>{item.title}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Message</h4>
                          <p>{item.message}</p>
                        </div>

                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <p>
                            {!item.isActive ? (
                              <span className='CCD'>Inactive</span>
                            ) : (
                              <span className='OK'>Active</span>
                            )}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Title</th>
                        <th>Message</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {notificationLists.map((item: any, i: number) => (
                        <tr key={item._id}>
                          <td>{i + 1}</td>
                          <td className='count'>{item.title}</td>
                          <td className='count'>{item.message}</td>
                          <td>
                            {!item.isActive ? (
                              <span className='CCD'>Inactive</span>
                            ) : (
                              <span className='OK'>Active</span>
                            )}
                          </td>
                          <td>
                            <select
                              name=''
                              id=''
                              onChange={(e) => {
                                const action = e.target.value
                                if (action === 'edit') {
                                  setSelectedNotification(item)
                                  setCreateNotification(true)
                                } else if (action === 'delete') {
                                  handleDeleteNotification(item._id)
                                } else if (action === 'deactivate') {
                                  // Handle deactivate action
                                  notify(
                                    'warn',
                                    'Deactivate action not implemented'
                                  )
                                } else if (action === 'activate') {
                                  // Handle activate action
                                  notify(
                                    'warn',
                                    'Activate action not implemented'
                                  )
                                }
                                e.target.value = '' // Reset dropdown
                              }}
                            >
                              <option value=''>-actions-</option>
                              <option value='edit'>Edit</option>
                              {profile.role === 'super admin' && (
                                <option value='delete'>Delete</option>
                              )}
                              {/* {item.isActive ? (
                                <option value='deactivate'>Deactivate</option>
                              ) : (
                                <option value='activate'>Activate</option>
                              )} */}
                            </select>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='fa:bell' />
                    <h1>No notifications To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Notifications
